import { Request } from '@group-devs/yfp7-global-modules'
import { TopNav, Footer } from '@group-devs/yfp7-global-modules/components/Block'
import { useRouter } from 'next/router'
import {useEffect} from 'react'
import Head from 'next/head'
import ReactGA from 'react-ga';

const request = new Request(process.env.apiDomain)

function Layout(props) {
  const router = useRouter()
  const site = props.global.site
  const auth = props.global.auth

  const { data: hub } = request.website.swrSite(site.accountId, "HUB")
  const { data: nav } = request.website.swrNavigation(hub ? hub.url : hub)
  const { data: tracker } = request.insights.swrTracking(site.id)

  useEffect(()=>{
    if (tracker)
    {
      if (tracker.ga_id)
      {
        ReactGA.initialize(tracker.ga_id);
        ReactGA.pageview(window.location.pathname + window.location.search);
      }
      if (tracker.matomo_id && tracker.matomoServer)
      {
        var _paq = window._paq = window._paq || [];
        _paq.push(['trackPageView']);
        _paq.push(['enableLinkTracking']);
        (function() {
          var u= (tracker.matomoServer.includes("http") ? "" : "//") + tracker.matomoServer.replace(/\/$/, "");
          _paq.push(['setTrackerUrl', u+'/matomo.php']);
          _paq.push(['setSiteId', tracker.matomo_id]);
          var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
          g.type='text/javascript'; g.async=true; g.src=u+'/matomo.js'; s.parentNode.insertBefore(g,s);
        })();
      }
    }
  }, [tracker])

  const title = site.name + " - Your Wellness Project"

  return (
    <div className="page-layout">
      <Head>
        <title>{title}</title>
        <meta name="author" content={site.name} />
        <meta property="og:url" content={ "https://" + site.url + router.asPath } key="url"/>
        <meta property="og:site_name" content={ site.name + " - Your Wellness Project"} />
        <meta property="og:type" content="Website"/>
        <meta property="og:image" content={"https://" + site.url+"/images/img-share02.jpg"} />
        <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap" rel="stylesheet"/>
      </Head>
      { nav  ? <TopNav auth={auth} host={props.global.host} site={site} navigation={nav.navigation} home={hub.url} /> : null }
      {props.children}
      { nav ? <Footer host={props.global.host} site={site} navigation={nav.footer_navigation} origin="wellness"/> : null }
      <style jsx global>{`
        body{
          font-family: 'Montserrat', sans-serif;
        }
        .footer__links{
          font-size: .9rem!important;
          font-weight:500;
        }
        
        .myStrip__media{
          background-color: transparent;
          border: 2px solid;
        }
        .myStrip__media svg{ 
          position: relative;
          top: -2px;
        }
        .footer__menuLinks{
          border-color: #ecca28;
        }
      `}</style>
    </div>
  )
}

export default Layout
